import { render, staticRenderFns } from "./index_home.vue?vue&type=template&id=0e10520c&scoped=true"
import script from "./index_home.vue?vue&type=script&lang=js"
export * from "./index_home.vue?vue&type=script&lang=js"
import style0 from "./index_home.vue?vue&type=style&index=0&id=0e10520c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e10520c",
  null
  
)

export default component.exports